import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";

import bgImage from "../../assets/images/bg-sign-in-basic.jpeg";
import Header from "../generalLayout/components/Header";
import BasicLayout from "./components/BasicLayout";

const AuthLayout = () => {

        const theme = useTheme();
        const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

        return (
                <BasicLayout is4Auth image={bgImage}>
                        <Header />
                        <Outlet />
                </BasicLayout >
        );
}

export default AuthLayout;